module.exports = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';